import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-client-main-panel',
  templateUrl: './client-main-panel.component.html',
  styleUrls: ['./client-main-panel.component.scss']
})
export class ClientMainPanelComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
